import { getProperty } from './getProperty';

export function doesPassNumeric(opening, property, value, greaterThan) {
  var openingProperty = getProperty(opening, property);
  if (openingProperty == null) openingProperty = '';
  var valueString = value.toSearchString(['>', '<']);
  if (valueString == null) valueString = '';
  if (typeof openingProperty == 'number') {
    if (valueString.startsWith('=')) {
      if (greaterThan) {
        return openingProperty >= parseFloat(valueString.toSearchString(['=']));
      } else {
        return openingProperty <= parseFloat(valueString.toSearchString(['=']));
      }
    } else {
      if (greaterThan) {
        return openingProperty > parseFloat(valueString.toSearchString());
      } else {
        return openingProperty < parseFloat(valueString.toSearchString());
      }
    }
  } else {
    if (valueString.startsWith('=')) {
      if (greaterThan) {
        return openingProperty.toString() >= valueString.toSearchString(['=']);
      } else {
        return openingProperty.toString() <= valueString.toSearchString(['=']);
      }
    } else {
      if (greaterThan) {
        return openingProperty.toString() > valueString.toSearchString();
      } else {
        return openingProperty.toString() < valueString.toSearchString();
      }
    }
  }
}
